// ════════════════════════════════════════════════════════
//  Константы для AI-Pirogov-dev
// ════════════════════════════════════════════════════════

export const captions = [
  "Изучаю ваш запрос...",
  "Определяю цель визуализации",
  "Создаю анатомическую сцену...",
  "Применяю предустановленные настройки...",
  "Проверяю...",
  "Почти готово...",
];

export const bodyOptions = [
  { value: "structures.json", label: "Анатомия" },
];

export const modeOptions = [
  { value: "standard", label: "Обычный" },
  { value: "clinical", label: "Клиницист" },
  { value: "surgical", label: "Хирург" },
];

export const instructions = {
  standard: {
    title: "📖 Обычный режим (Образовательный)",
    description: "Для изучения анатомии, структуры органов и пространственных взаимосвязей.",
    examples: [
      {
        formula: "Внутренняя анатомия [Органа]",
        items: [
          "Внутренняя анатомия головного мозга",
          "Внутренняя анатомия сердца",
        ],
      },
      {
        formula: "[Система] [Области/Органа]",
        items: [
          "Сосуды печени",
          "Нервы предплечья",
        ],
      },
      {
        formula: "Используйте общие понятия",
        items: [
          "Органы мочевыделительной системы",
          "Органы пищеварительной системы",
        ],
      },
    ],
    colorInfo: "Структуры окрашиваются случайным образом для легкого различия. При необходимости отключите окрашивание в Расширенных настройках.",
  },
  clinical: {
    title: "🩺 Клинический режим",
    description: "Демонстрирует причинно-следственные связи между анатомическими структурами.",
    examples: [
      {
        formula: "Почему [Симптом] из-за [Причины]",
        items: [
          "Почему синдром запястного канала вызывает онемение?",
        ],
      },
      {
        formula: "[Причина], вызывающая [Эффект]",
        items: [
          "Грыжа диска, вызывающая компрессию нервного корешка",
        ],
      },
      {
        formula: "Механизм [Синдрома/Состояния]",
        items: [
          "Механизм синдрома верхней апертуры грудной клетки",
        ],
      },
    ],
    colorInfo: "Причинная структура = зеленая, структуры внутреннего контекста = жёлтые. Можно отключить окрашивание с помощью чекбокса в форме.",
  },
  surgical: {
    title: "🔪 Хирургический режим",
    description: "Планирование хирургических вмешательств, коридоров доступа и структур, подверженных риску.",
    examples: [
      {
        formula: "[Тип доступа] к [Целевой структуре]",
        items: [
          "Трансназальный эндоскопический доступ к аденоме гипофиза",
        ],
      },
      {
        formula: "[Процедура] с сохранением [Структур риска]",
        items: [
          "Тиреоидэктомия с сохранением возвратного гортанного нерва",
        ],
      },
    ],
    colorInfo: "Целевая структура = зеленая для точной идентификации. Можно отключить окрашивание с помощью чекбокса в форме.",
  },
};

/** Максимальное количество опросов статуса задачи (~15 минут при интервале 2с;
 * replan удваивает время задачи (2 полных прогона) + запас на вложенные
 * LLM-ретраи; укладывается в Celery-лимит 30 мин */
export const MAX_POLL_COUNT = 450;
